<template>
    <div>
    <div class="container container--small pdt-50 pdb-50">
        <div class="t-headline5 font-b mgt-50 mgb-16 t-center">{{$t('1692')}}</div>
        <div class="t-body1 font-r t-color-bodyGrayA t-center l-spacing48 pdl-24 pdr-24">
            {{$t('1693')}}<br>
                {{$t('1694',{str: brandName})}}
        </div>
        <div class="pdl-24 pdr-24">
            <div class="mgt-50">
                <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText w-full b-radius4" @click="moveDegree()" @keypress="moveDegree()" tabindex="0">
                    <div class="mdc-button__ripple"></div>
                    <span class="mdc-button__label t-body2 font-r">{{$t('1695')}}</span>
                </button>
            </div>
        </div>
    </div>
    </div>
    
</template>

<script>
/**
 * 회원가입 - 승인완료(sign up - approved component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'
import popupApi from '@/api/popupApi.js'
export default {
    data() {
        return {
            brandName: '',
            studentContents: '',
            parentContents: '',
            instructorContents: '',
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
    },

    mounted() {
        this.setMaterialUi()
        this.brandName = BRAND_NAME
        
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('join', ['INIT_JOIN_STORE']),

        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        moveDegree() {
           
            //this.$router.push('/login')
            window.location = '/login'
            
        }
    },
}
</script>